
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/new-password",
      function () {
        return require("private-next-pages/account/new-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/new-password"])
      });
    }
  